import { type LanguageCode } from '../../utils/language';
import { merchantInfoByProductUUID } from '../../utils/productUUIDConstants';

export const getDisclosureLinks = (
  productUUID: string,
  languageCode: LanguageCode
) => {
  return {
    rewardsTermsAndConditions:
      merchantInfoByProductUUID[productUUID].rewardsTerms[languageCode],
    cca: merchantInfoByProductUUID[productUUID].cardholderAgreement[
      languageCode
    ],
  };
};
